/* eslint-disable max-lines */
/* eslint-disable  import/no-default-export */

import { get, last } from 'lodash';

import {
  addJkMarkers,
  removeJkMarkers,
  selectJk,
  selectJkHouse,
  mapDragEnd,
  updateMap,
  resetValidation,
  geoObjectProcessed,
  mapReady,
} from '../../../../blocks/segments/address/address.events';

import template from './map.jade';
import iconTemplate from './map-icon-template.jade';
import balloonTemplate from './map-balloon-template.jade';
import { computeMarkerZoomByGeoType } from './utils';
import { trackGeo } from '../tracking/tracking';
import { selectIsAddressEditingExpired } from '../../../../../../shared/selectors/offer/geo';

export default angular.module('cian.addForm.map', []).directive('cianAfAddressMap', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'geoSelectorService',
    '$window',
    '$rootScope',
    '$scope',
    '$compile',
    'geoService',
    'deviceService',
    'telemetryService',
    'analyticsService',
    'formIdService',
    'store',
    function (
      geoSelectorService,
      $window,
      $rootScope,
      $scope,
      $compile,
      geoService,
      deviceService,
      telemetryService,
      analyticsService,
      formIdService,
      store,
    ) {
      const state = store.getState();
      const isAddressEditingExpired = selectIsAddressEditingExpired(state);

      this.isMobile = deviceService.isMobile;

      telemetryService.mark('addform.map-init-start');

      let onScopeDestroy = angular.noop;

      function getMapCenterByCoordsObj({ lat = 55.755814, lng = 37.617635 }) {
        return [lat, lng];
      }

      function getMapZoomByGeoTypeObj(geoTypeObj = { type: 'location' }) {
        return computeMarkerZoomByGeoType(geoTypeObj.type);
      }

      geoSelectorService.ready(ymaps => {
        const getCoordinates = () => {
          const geoCoord = get(this.ad, 'geo.coordinates');
          if (geoCoord) {
            return geoCoord;
          } else {
            return geoService.userGeo
              ? {
                  lat: geoService.userGeo.lat,
                  lng: geoService.userGeo.lng,
                }
              : {};
          }
        };

        this.geoObjectProcessed = false;

        const adGeoAddress = get(this.ad, 'geo.address', []);
        const adGeoAddressLastObj = last(adGeoAddress);
        const zoomMap = getMapZoomByGeoTypeObj(adGeoAddressLastObj);

        const adGeoCoords = getCoordinates();
        const centerMap = getMapCenterByCoordsObj(adGeoCoords);

        this.createMap = () => {
          this.map = new ymaps.Map(
            $scope.mapElement[0],
            {
              center: centerMap,
              zoom: zoomMap,
              controls: ['zoomControl'],
            },
            { suppressMapOpenBlock: true },
          );
          this.map.behaviors.disable('scrollZoom');

          const iconHtmlLayout = ymaps.templateLayoutFactory.createClass(iconTemplate);

          this.mark = new ymaps.Placemark(
            centerMap,
            {},
            {
              draggable: !isAddressEditingExpired,
              iconLayout: iconHtmlLayout,
              iconShape: {
                type: 'Circle',
                coordinates: [0, -24],
                radius: 22,
              },
              iconImageHref: require('../../../../resources/assets/images/here.svg'),
            },
          );
          this.mark.events.add('dragend', this.dragEndMarker);

          this.jkMarkers = [];

          this.map.geoObjects.add(this.mark);

          this.map.events.add('click', this.handleMoveMarker);
          this.map.events.add('dblclick', this.handleDoubleClick);
        };

        this.addJkMark = (jk, isHouse) => {
          let placemark;

          const onSelect = () => {
            if (!isHouse) {
              $rootScope.$emit(selectJk, { jk });
            } else {
              $rootScope.$emit(selectJkHouse, { jkHouse: jk });
            }
            placemark.balloon.close();
          };

          const iconHtmlLayout = ymaps.templateLayoutFactory.createClass(iconTemplate);
          const balloonLayout = ymaps.templateLayoutFactory.createClass(balloonTemplate, {
            build() {
              // eslint-disable-line
              balloonLayout.superclass.build.call(this);
              document.getElementById('map-balloon__action-select').addEventListener('click', onSelect);

              const actionCloseParent = document.getElementById('map-balloon__action-close');
              const actionCloseTemplate = '<cian-af-icon name="close" ng-click="close()"></cian-af-icon>';
              const scope = $scope.$new(true);
              scope.close = () => placemark.balloon.close();
              const closeButton = $compile(actionCloseTemplate)(scope)[0];
              actionCloseParent.appendChild(closeButton);
            },
            clear() {
              // eslint-disable-line
              document.getElementById('map-balloon__action-select').removeEventListener('click', onSelect);
              balloonLayout.superclass.build.call(this);
            },
          });

          const iconName = isHouse && jk.isFinished ? 'keys' : 'crane';

          const coordinates = [jk.geo.coordinates.lat, jk.geo.coordinates.lng];

          placemark = new ymaps.Placemark(
            coordinates,
            {
              name: jk.name,
              address: jk.geo.address,
            },
            {
              balloonLayout,
              hideIconOnBalloonOpen: false,
              iconLayout: iconHtmlLayout,
              iconShape: {
                type: 'Circle',
                coordinates: [0, -24],
                radius: 22,
              },
              iconImageHref: require(`../../../../resources/assets/images/${iconName}.svg`),
            },
          );

          this.jkMarkers.push(placemark);
          this.map.geoObjects.add(placemark);
          const map = this.map;
          placemark.events.add('click', function () {
            map.setCenter(coordinates);
          });
        };

        this.setMarker = (coords, zoom) => {
          this.mark.geometry.setCoordinates(coords);
          this.map.setZoom(zoom);

          let [lat, lng] = coords;

          this.map.panTo([+lat, +lng], { duration: 0, flying: false });
        };

        this.handleMoveMarker = e => {
          if (isAddressEditingExpired) {
            return;
          }

          this.shouldMoveMarker = true;

          setTimeout(() => {
            this.moveMarker(e);
          }, 200);
        };

        this.handleDoubleClick = () => {
          if (this.shouldMoveMarker) {
            this.shouldMoveMarker = false;
          }
        };

        const onMarkerMoved = () => {
          if ($window.ca) {
            trackGeo(analyticsService.adAnalyticsCategory, 'map_pin_move', formIdService.getId());
          }
        };

        this.moveMarker = e => {
          if (this.shouldMoveMarker) {
            const coords = e.get('coords');
            this.mark.geometry.setCoordinates(coords);
            $rootScope.$emit(mapDragEnd, coords.slice().reverse().join(','));
            onMarkerMoved();
          }
        };

        this.dragEndMarker = () => {
          const coords = this.mark.geometry.getCoordinates();
          $rootScope.$emit(mapDragEnd, coords.slice().reverse().join(','));
          onMarkerMoved();
        };

        this.removeJkMarkers = () => {
          while (this.jkMarkers.length) {
            const placemark = this.jkMarkers.pop();
            this.map.geoObjects.remove(placemark);
          }
        };

        /**
         * @description устанавливает новый зум и маркер на карте по типу и координатам гео-объекта
         *
         * @param гео объект, возвращаемый нашим внутренним API
         */
        this.updateMap = geoObject => {
          if (geoObject.coordinates && geoObject.coordinates.lat && geoObject.coordinates.lng && geoObject.geoType) {
            const isLocationRequired = geoObject.accuracyError === 'locationRequired';

            const zoom = computeMarkerZoomByGeoType(geoObject.geoType, isLocationRequired);

            this.setMarker([geoObject.coordinates.lat, geoObject.coordinates.lng], zoom);
          }
        };

        this.resetValidation = () => {
          if (this.mark && (!this.ad.geo.address || !this.ad.geo.address[0])) {
            this.mark.geometry.setCoordinates(centerMap);
            this.map.setCenter(centerMap);
          }
        };

        this.createMap();
        $rootScope.$emit(mapReady);

        const detachAddJkMarkers = $rootScope.$on(addJkMarkers, (event, { jks, isHouse }) =>
          jks.forEach(jk => this.addJkMark(jk, isHouse)),
        );
        const detachRemoveJkMarkers = $rootScope.$on(removeJkMarkers, () => this.removeJkMarkers());
        const detachUpdateMap = $rootScope.$on(updateMap, (event, geoObject) => this.updateMap(geoObject));
        const detachResetValidation = $rootScope.$on(resetValidation, () => this.resetValidation());
        const detachGeoObjectProcessed = $rootScope.$on(
          geoObjectProcessed,
          (event, status) => (this.geoObjectProcessed = status),
        );

        onScopeDestroy = () => {
          detachAddJkMarkers();
          detachRemoveJkMarkers();
          detachUpdateMap();
          detachResetValidation();
          detachGeoObjectProcessed();
        };

        telemetryService.mark('addform.map-init-end');
        telemetryService.sendMeasuredTimer('addform.map-init', 'addform.map-init-start', 'addform.map-init-end');
      });

      $scope.$on('$destroy', () => {
        onScopeDestroy();
      });
    },
  ],
  controllerAs: 'map',
  template,
  replace: true,
})).name;
